function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "LANDING-DONACI\xD3N-SANGRE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-donacion-sangre",
  transform: "translate(-792.000000, -1712.000000)"
}, React.createElement("g", {
  id: "Counter",
  transform: "translate(120.000000, 1184.000000)"
}, React.createElement("g", {
  id: "tooltip",
  transform: "translate(672.000000, 528.000000)"
}, React.createElement("path", {
  d: "M5,0 L34,0 C36.7614237,-5.07265313e-16 39,2.23857625 39,5 L39,27 C39,29.7614237 36.7614237,32 34,32 L23.3596191,32 L23.3596191,32 L19.5,36.3076172 L15.3693848,32 L5,32 C2.23857625,32 3.38176876e-16,29.7614237 0,27 L0,5 C-3.38176876e-16,2.23857625 2.23857625,5.07265313e-16 5,0 Z",
  id: "Rectangle",
  fill: "#FFFFFF"
}), React.createElement("text", {
  id: "0,1-l",
  fontFamily: "Inter_Bold, Inter",
  fontSize: 16,
  fontWeight: "bold",
  letterSpacing: -0.666666667,
  fill: "#131313"
}, React.createElement("tspan", {
  x: 6,
  y: 22
}, "0,1 l"))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 39 37"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/tooltip.fedd3a88.svg";
export { SvgComponent as ReactComponent };